import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AccountAuthService } from '../../shared/account-auth.service';

@Component({
  selector: 'app-account-verify',
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  templateUrl: './account-verify.html',
  styleUrl: './account-verify.scss',
})
export class AccountVerify {
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);
  private readonly auth = inject(AccountAuthService);

  readonly form = this.fb.nonNullable.group({
    email: [
      this.auth.getPendingEmail(),
      [Validators.required, Validators.email],
    ],
    passcode: [
      '',
      [Validators.required, Validators.pattern(/^[0-9]{6}$/)],
    ],
  });

  isLoading = false;
  errorMessage = '';

  submit() {
    if (this.form.invalid || this.isLoading) {
      this.form.markAllAsTouched();
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    const { email, passcode } = this.form.getRawValue();

    this.auth.verifyAccount(email, passcode).subscribe({
      next: () => {
        this.isLoading = false;
        this.router.navigateByUrl(this.auth.defaultDashboardPath());
      },
      error: (message: string) => {
        this.isLoading = false;
        this.errorMessage = message;
      },
    });
  }
}
